import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import RecotizacionesTable from "../components/RecotizacionesTable";
import { useGlobalContext } from "../../../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { ReportService } from "../../../services/ReportService.js";
import { getDetalleCotizacionByIdCotizacion } from "../../../services/CotizacionService.js";
import useCotizaciones from "../../../shared/hooks/useCotizaciones.js";

const Recotizacion = (props) => {
  const toast = useRef(null);
  const reportService = new ReportService();
  const [activeTab] = useState("Vigentes");
  const [filters2] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [fila, setFila] = useState(null);
  const [producto, setProducto] = useState(null);
  const { baseUrl } = useGlobalContext();
  const estados = ["A", "E"];
  const usuarioId = sessionStorage.getItem("usuario_id");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const formatDate = (value) => {
    return value.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const { cotizaciones, loading2, getCotizaciones } = useCotizaciones(
    baseUrl,
    usuarioId,
    ["6", "7"],
    setLoading
  );

  useEffect(() => {
    getCotizaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const desdeBodyTemplate = (rowData) => {
    return formatDate(rowData.desde);
  };

  const hastaBodyTemplate = (rowData) => {
    return formatDate(rowData.hasta);
  };

  const estadoBodyTemplate = (rowData) => {
    return (
      <span className={`customer-badge status-${rowData.estado}`}>
        {rowData.estado}
      </span>
    );
  };

  const estadoFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={estados}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        itemTemplate={statusItemTemplate}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      await reportService.exportDetalleCotizaciones(baseUrl, ["6", "7"]);
      toast.current?.show({
        severity: "success",
        summary: "Exportación exitosa",
        detail: "Se descargó el archivo detalle_cotizaciones.xlsx",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo exportar el archivo Excel",
        life: 3000,
      });
    } finally {
      setExporting(false);
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          icon="pi pi-eye"
          label="Ver detalles"
          className="p-button-rounded p-button-info p-button mr-2 mb-2 mt-2"
          outlined
          onClick={() => handleRowClick(rowData)}
        />
      </div>
    );
  };

  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");

    if (rowData.estado.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const data = await getDetalleCotizacionByIdCotizacion(baseUrl, idCotizacion);

        if (data.mensaje === "OK") {
          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          navigate(newUrl);
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        console.error(error);
        alert("Hubo un error al crear la cotización");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="grid table-demo">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Recotizaciones</h4>
          <h6 style={{ marginTop: "5px" }}>¿Qué Asignaciones han sido modificadas?</h6>
        </div>  
      </div>

      <Card className="col-12">
        <Button
          label="Exportar Excel"
          icon="pi pi-file-excel"
          className="p-button-rounded p-button-success mb-2"
          onClick={handleExportExcel}
          loading={exporting}
          disabled={loading || loading2}
        />
        <RecotizacionesTable
          activeTab={activeTab}
          recotizaciones={cotizaciones || []}
          filters={filters2}
          loading={loading || loading2}
          desdeBodyTemplate={desdeBodyTemplate}
          dateFilterTemplate={dateFilterTemplate}
          hastaBodyTemplate={hastaBodyTemplate}
          estadoBodyTemplate={estadoBodyTemplate}
          estadoFilterTemplate={estadoFilterTemplate}
          actionBodyTemplate={actionBodyTemplate}
          setDisplayBasic={setDisplayBasic}
          displayBasic={displayBasic}
          fila={fila}
          setFila={setFila}
          producto={producto}
          setProducto={setProducto}
          handleRowClick={handleRowClick}
        />
      </Card>
        
    </div>
  );
};

export default Recotizacion;
